/* @flow */
// typecheck: ignore file
import React from 'react';
import userAgent from 'lib/currentUserAgent';
import invariant from 'invariant';

import createChainedFunction from 'utils/createChainedFunction';

/**
 * Copy text to the user's clipboard
 *
 * ```example
 *  <ClipboardTrigger
 *    text="http://www.google.com/"
 *    onCopy={() => window.alert('Link copied!')}>
 *    <Link>
 *      Click here to copy the link to your clipboard.
 *    </Link>
 *  </ClipboardTrigger>
 * ```
 */

class ClipboardTrigger extends React.Component {
  static propTypes = {
    text: React.PropTypes.string.isRequired,
    onCopy: React.PropTypes.func,
  }

  static defaultProps = {
    onCopy: () => {},
  }

  handleClick = (event: SyntheticMouseEvent) => {
    event.preventDefault();

    const input = document.createElement('input');
    input.readOnly = true;
    input.style.cssText = `
      position: absolute;
      top: -9999px;
    `;
    input.value = this.props.text;
    document.body.appendChild(input);
    input.select();

    try {
      const success = document.execCommand('copy');
      document.body.removeChild(input);
      invariant(success, 'unable to copy');
      this.props.onCopy();
    } catch (e) {
      const message = userAgent.mac() ?
        'Press Cmd-C to copy to clipboard' :
        'Press Control-C to copy to clipboard';

      if (window.prompt(message, this.props.text)) { // eslint-disable-line no-alert
        this.props.onCopy();
      }
    }
  }

  render() {
    const trigger = React.Children.only(this.props.children);
    return React.cloneElement(trigger, {
      onClick: createChainedFunction(this.handleClick, this.props.onClick),
    });
  }
}

export default ClipboardTrigger;



// WEBPACK FOOTER //
// ./src/components/ClipboardTrigger.jsx